<template>
    <cBody class="algorithm-data ">
        <header slot="header" class="c-body-header">
            <div class="header-row">
                <div class="header-row-left">
                    <!-- 算法ID -->
                    <span class="status-text">算法名称</span>
					<Select v-model="tableParams.algorithmnId" style="width:200px">
                        <Option v-for="item in algorithmnList.filter(i=>i.status)" :value="item.id" :label="item.name" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </div>
                <div class="header-row-right">
					<!-- 预设日期按钮 -->
					<c-date-picker :startDay.sync="tableParams.startDate" 
                                   :endDay.sync="tableParams.endDate" />
				</div>
            </div>
            <div class="header-row">
                <div class="header-row-left">
                    <span class="status-text">维度</span>
                    <CheckboxGroup size="large" v-model="dimension">
                        <Checkbox v-for="item in dimensionList" :label="item.value" :key="item.value">
                            <span class="dimension-text">{{item.label}}</span>
                        </Checkbox>
                    </CheckboxGroup>
                </div>
                <div class="header-row-right">
					<!-- 刷新 -->
                    <button @click="getList(true)" class="header-button-primary small">查询</button>
                    <!-- 下载报表 -->
                    <button @click="onClickDownload" class="header-button-primary small" style="margin:0">下载</button>
				</div>
            </div>

        </header>
        <section slot="section" class="c-body-section">
            <table class="c-body-table">
				<!-- 表头 -->
				<thead class="table-thead">
					<tr class="table-tr cursor-pointer">
						<td 
                            class="table-td-primary table-sort" 
                            :class="{'active':tableParams.orderName==item.value}"
                            v-for="(item,index) in tableList" 
                            :key="index"
                            @click="sortTable(item.value)"
                        >
                            <span>{{item.label}}</span>
                            <Icon v-if="tableParams.orderName==item.value"
								  :class="{'table-sort-icon':tableParams.orderType=='asc'}"
								  type="arrow-down-b" />
                        </td>
					</tr>
				</thead>
				<!-- 表头 -->                
				<tbody class="table-tbody">
            		<tr v-for="(item,index) in originData" class="table-tr" :key="index">
						<td class="table-td-primary" v-if="item.day">{{item.day}}</td>
						<td class="table-td-primary" v-if="item.hour||typeof(item.hour)=='number'">{{item.hour}}</td>
						<td class="table-td-primary" v-if="item.seriesId">{{item.seriesId}}</td>
						<td class="table-td-primary" v-if="item.campaignId">{{item.campaignId}}</td>
						<td class="table-td-primary" v-if="item.offerId">{{item.offerId}}</td>
						<td 
                            class="table-td-primary showregular" 
                            style="max-width:1rem;"
                            :title="getAlgorithmnName(item.algorithmnId)"
                            v-if="item.algorithmnId||typeof(item.algorithmnId)=='number'"
                            >{{getAlgorithmnName(item.algorithmnId)}}</td>
						<td class="table-td-primary">{{item.bidReq}}</td>
						<td class="table-td-primary">{{item.imp}}</td>
						<td class="table-td-primary">{{item.click}}</td>
						<td class="table-td-primary">{{item.ctr}}</td>
						<td class="table-td-primary">{{item.deal}}</td>
						<td class="table-td-primary">{{item.cvr}}</td>
						<td class="table-td-primary">{{item.cpm}}</td>
						<td class="table-td-primary">{{item.cpc}}</td>
						<td class="table-td-primary">{{item.cpa}}</td>
						<td class="table-td-primary">{{item.spends}}</td>
					</tr>
				</tbody>
            </table>
        </section>
        <footer slot="footer" class="c-body-footer">
        	<!-- 分页器 -->
			<c-page :table-params.sync="oldParams"
                    :page-bean.sync="pageBean"
                    class="foot-row"
                    @on-change="getNextList(false)"
                    @on-page-size-change="getNextList(false)" />
        </footer>
    </cBody>
</template>

<script>
import cBody from '@/components/commons/cBody.vue';
import cPage from '@/components/commons/cPage.vue';
import cDatePicker from '@/components/commons/cDatePicker.vue';
import mixins from '@/mixins/index.js';
export default {
    name: 'AlgorithmData',
    mixins: [mixins],
    components: { cBody, cPage, cDatePicker },
    data() {
        return {
            algorithmnList: [],
            //表格参数
            tableParams: {
                page: 1,
                pageSize: 10,
                startDate: this.mixinGetDate(),
                endDate: this.mixinGetDate(),
                algorithmnId: -1,
                dimensions: 'algorithmn',
                orderName: 'algorithmn',
                orderType: 'desc',
            },
            oldParams: {
                page: 1,
                pageSize: 10,
                startDate: this.mixinGetDate(),
                endDate: this.mixinGetDate(),
                algorithmnId: -1,
                dimensions: 'algorithmn',
                orderName: '0',
                orderType: 'desc',
            },
            pageBean: {
                currentPage: 1,
                pageSize: 10,
                startNum: 0,
                totalNum: 0,
                totalPage: 0,
            },
            originData: [],
            dimension: ['algorithmn'],
            dimensionList: [
                { value: 'day', label: '天' },
                { value: 'hour', label: '小时' },
                { value: 'series', label: '广告系列' },
                { value: 'campaign', label: '广告组' },
                { value: 'offer', label: '广告' },
                { value: 'algorithmn', label: '算法名称' },
            ],
        };
    },
    computed: {
        currentDimensions() {
            return this.dimension.length ? this.dimension.join(',') : '';
        },
        tableList() {
            const arr = [
                { label: '请求量', value: 'bidReq' },
                { label: '展示量', value: 'imp' },
                { label: '点击量', value: 'click' },
                { label: 'CTR', value: 'ctr' },
                { label: '转化量', value: 'deal' },
                { label: 'CVR', value: 'cvr' },
                { label: 'CPM', value: 'cpm' },
                { label: 'CPC', value: 'cpc' },
                { label: 'CPA', value: 'cpa' },
                { label: '花费', value: 'spends' },
            ];
            const dimensions = this.tableParams.dimensions;
            if (dimensions.includes('algorithmn')) arr.unshift({ label: '算法名称', value: 'algorithmn' });
            if (dimensions.includes('offer')) arr.unshift({ value: 'offer', label: '广告' });
            if (dimensions.includes('campaign')) arr.unshift({ value: 'campaign', label: '广告组' });
            if (dimensions.includes('series')) arr.unshift({ value: 'series', label: '广告系列' });
            if (dimensions.includes('hour')) arr.unshift({ value: 'hour', label: '小时' });
            if (dimensions.includes('day')) arr.unshift({ value: 'day', label: '日期' });
            return arr;
        },
    },
    mounted() {
        this.getList();
        this.getAlgorithmnList();
    },
    methods: {
        /**
         * @desc 获取列表
         * @param {Boolean} isInit 初始化页数
         */
        async getList(isInit = true) {
            //验证
            if (!this.dimension.length) {
                this.$Message.error({ content: '请选择至少一个维度', duration: 1.5 });
                return;
            }
            //初始化页数
            if (isInit) this.tableParams.page = 1;
            //计算维度排序
            const dimensions = this.currentDimensions;
            this.tableParams.dimensions = dimensions;
            if (dimensions.includes('day')) this.tableParams.orderName = 'day';
            else if (dimensions.includes('hour')) this.tableParams.orderName = 'hour';
            else if (dimensions.includes('series')) this.tableParams.orderName = 'series';
            else if (dimensions.includes('campaign')) this.tableParams.orderName = 'campaign';
            else if (dimensions.includes('offer')) this.tableParams.orderName = 'offer';
            else if (dimensions.includes('algorithmn')) this.tableParams.orderName = 'algorithmn';
            this.tableParams.orderType = 'desc';
            const params = { ...this.tableParams };
            //记录请求参数
            this.oldParams = { ...this.tableParams };
            //修改算法id值
            if (params.algorithmnId == -1) params.algorithmnId = '';
            const res = await this.$axios.get(this.$port.algorithmn.data, { params });
            if (res.status == 200) {
                this.originData = res.data.list;
                this.pageBean = res.data.pageBean;
            }
        },
        /**
         * @desc 获取下一页的列表
         */
        async getNextList(isInit = true) {
            if (isInit) this.oldParams.page = 1;
            const params = { ...this.oldParams };
            //初始化页数
            if (params.algorithmnId == -1) params.algorithmnId = '';
            const res = await this.$axios.get(this.$port.algorithmn.data, { params });
            if (res.status == 200) {
                this.originData = res.data.list;
                this.pageBean = res.data.pageBean;
            }
        },
        /**
         * @desc 获取列表
         */
        async getAlgorithmnList() {
            const res = await this.$axios.get(this.$port.algorithmn.list);
            if (res.status == 200) this.algorithmnList = [{ id: -1, status: 1, name: '全部' }, ...res.data];
        },
        /**
         * @desc 下载报表
         */
        onClickDownload() {
            const params = { ...this.oldParams };
            if (params.algorithmnId == -1) params.algorithmnId = '';
            let initString = `${this.$port.algorithmn.downloadData}?rd=${new Date().getTime()}`;
            window.location.href = Object.entries(params).reduce((a, b) => `${a}&${b[0]}=${b[1]}`, initString);
        },
        /**
         * @desc 表格排序
         * @param {String} value: 排序的索引
         */
        sortTable(value) {
            // 无效排序返回
            if (!value) return;
            if (value == this.tableParams.orderName) {
                this.tableParams.orderType = this.tableParams.orderType == 'asc' ? 'desc' : 'asc';
            } else {
                this.tableParams.orderName = value;
                this.tableParams.orderType = 'desc';
            }
            this.oldParams.orderName = this.tableParams.orderName;
            this.oldParams.orderType = this.tableParams.orderType;
            this.getNextList(true);
        },
        /**
         * @desc 获取算法名
         * @param {Number} id 算法id
         * @return
         */
        getAlgorithmnName(id) {
            if (this.algorithmnList.length < 2) return '';
            const arr = this.algorithmnList.filter(a => a.id == id);
            if (arr.length) return arr[0].name;
            else return `算法${id}`;
        },
    },
};
</script>

<style lang="scss">
.algorithm-data {
    .status-text {
        font-size: 0.14rem;
        width: 0.6rem;
    }
    .dimension-text {
        font-size: 0.14rem;
        position: relative;
        top: 0.01rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/Algorithm/Data.vue